/**
 * config.ts
 */
import Screen from '@screen';
import { AnimatorType, TypeConfig } from './types';
import { DELAY, DURATION, OFFSET } from '@shared/types/constants/animations';

/**
 * Layout constants used only by the presets below.
 */
const GRID_WIDTH = 1920;
const SEARCH_TOP = 66;

/**
 * Per-page animation presets. Adding animation to a new page is just adding
 * an AnimatorType member and its preset here.
 */
const CONFIG: Record<AnimatorType, TypeConfig> = {
  [AnimatorType.CHANNELS_CHOICE]: {
    horizontal: {
      offset: OFFSET.CHANNELS_CHOICE_HORIZONTAL,
    },
    style: { paddingRight: `${50 * Screen.widthRatio}px` },
  },
  [AnimatorType.CHANNELS_LINEUP]: {
    horizontal: {
      offset: OFFSET.MAIN_HORIZONTAL,
      duration: DURATION.RAILS_WRAPPER,
    },
  },
  [AnimatorType.DETAIL]: {
    horizontal: {
      offset: OFFSET.MAIN_HORIZONTAL,
    },
  },
  [AnimatorType.GRID]: {
    horizontal: {
      offset: OFFSET.MAIN_HORIZONTAL,
      duration: DURATION.GRID_WRAPPER,
    },
    vertical: {
      offset: OFFSET.GRID_VERTICAL,
      duration: DURATION.MAIN_CONTENT_VERTICAL_TRANSFORM,
      delay: DELAY.MAIN_CONTENT_VERTICAL,
      easing: 'linear',
      extraTransition: `height ${DURATION.MAIN_CONTENT_VERTICAL_HEIGHT}ms ease-in-out ${DELAY.MAIN_CONTENT_VERTICAL}ms`,
      style: {
        position: 'relative',
        width: `${GRID_WIDTH * Screen.widthRatio}px`,
      },
    },
  },
  [AnimatorType.RAILS]: {
    horizontal: {
      offset: OFFSET.MAIN_HORIZONTAL,
      duration: DURATION.RAILS_WRAPPER,
      style: { position: 'absolute', top: 0, width: 'max-content' },
    },
    vertical: {
      offset: OFFSET.MAIN_VERTICAL,
      duration: DURATION.RAILS_WRAPPER,
      delay: DURATION.RAILS_WRAPPER,
      style: { display: 'flex', flexDirection: 'column' },
    },
  },
  [AnimatorType.SEARCH]: {
    horizontal: {
      offset: OFFSET.SEARCH_HORIZONTAL,
      style: {
        position: 'absolute',
        top: `${SEARCH_TOP * Screen.widthRatio}px`,
      },
    },
  },
  [AnimatorType.SETTING]: {
    horizontal: {
      offset: OFFSET.MAIN_HORIZONTAL,
    },
  },
};

export default CONFIG;
